export const SET_FORM_FILTERS = "[FORM_FILTERS] SET_FORM_FILTERS";
export const LOAD_INSTRUMENTS_SUCCESS =
  "[FORM_FILTERS] LOAD_INSTRUMENTS_SUCCESS";
export const SELECT_INSTRUMENTS = "[FORM_FILTERS] SELECT_INSTRUMENTS";
export const SELECT_GROUP_INSTRUMENTS =
  "[FORM_FILTERS] SELECT_GROUP_INSTRUMENTS";
export const SELECT_INSTRUMENTS_TO_MONITOR =
  "[FORM_FILTERS] SELECT_INSTRUMENTS_TO_MONITOR";
export const SET_SORT_KEY = "[FORM_FILTERS] SET_SORT_KEY";
